import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export class Tab extends Component {
  /**
   * Label/título do menu.
   *
   * @type {String}
   */
  label = null;

  /**
   * ID da tab.
   */
  tabId = null;

  componentDidMount () {
    this.tabId = this.props.tabId;
    this.label = this.props.label;
  }

  render () {
    const {
      className,
      children
    } = this.props;

    return (
      <div className={classnames(className)}>
        {children}
      </div>
    );
  }
}

Tab.defaultProps = {
  className: "tabbed-view__tab",
  children: null
};

Tab.propTypes = {
  tabId: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  children: PropTypes.node
};
